import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageBanner from '../components/PageBanner';
import './Technologies.css';

const Technologies = () => {
  useEffect(() => {
    document.title = 'Technologies - SOFTORA Technologies';
  }, []);

  const [activeCategory, setActiveCategory] = useState('all');

  const techCategories = [
    { id: 'all', label: 'All Technologies' },
    { id: 'frontend', label: 'Frontend & Web' },
    { id: 'mobile', label: 'Mobile Apps' },
    { id: 'backend', label: 'Backend & Cloud' },
    { id: 'ai-3d', label: 'AI & 3D Tech' }
  ];

  const technologies = [
    {
      name: "React.js",
      category: "frontend",
      logoType: "react",
      type: "Frontend Framework",
      desc: "Declarative component-based UI library delivering lightning fast rendering and rich single-page application experiences.",
      features: ["Virtual DOM", "Component Architecture", "Hooks Ecosystem", "Unidirectional Data Flow"]
    },
    {
      name: "Flutter",
      category: "mobile",
      logoType: "flutter",
      type: "Cross-Platform Framework",
      desc: "Google's UI toolkit for compiling beautiful, natively compiled applications for mobile from a single codebase.",
      features: ["60 FPS Performance", "Multi-Platform Codebase", "Custom UI Widgets", "Native ARM Code"]
    },
    {
      name: "Firebase",
      category: "backend",
      logoType: "firebase",
      type: "Cloud Platform",
      desc: "Google's backend platform providing real-time NoSQL databases, serverless functions, authentication, and hosting.",
      features: ["Firestore Realtime Sync", "Cloud Functions", "OAuth Security", "Zero DevOps Overhead"]
    },
    {
      name: "Node.js",
      category: "backend",
      logoType: "node",
      type: "Server Runtime",
      desc: "Event-driven asynchronous JavaScript runtime designed to build scalable high-throughput network applications.",
      features: ["Non-blocking I/O", "Microservices Architecture", "V8 Engine Speed", "NPM Ecosystem"]
    },
    {
      name: "Next.js",
      category: "frontend",
      logoType: "next",
      type: "Full-Stack Web Framework",
      desc: "The React framework for the Web with Server-Side Rendering (SSR), Static Site Generation, and automated SEO optimization.",
      features: ["Server Components", "Automatic Code Splitting", "Optimized Core Web Vitals", "API Routes"]
    },
    {
      name: "TypeScript",
      category: "frontend",
      logoType: "ts",
      type: "Typed Programming Language",
      desc: "Typed superset of JavaScript that catches errors early in development and enables reliable large-scale code refactoring.",
      features: ["Static Type Safety", "Modern ECMAScript", "Enhanced Tooling & IDE", "Zero Runtime Overhead"]
    },
    {
      name: "Python",
      category: "ai-3d",
      logoType: "python",
      type: "AI & Automation Language",
      desc: "Versatile powerhouse language behind modern AI model integrations, data analysis, neural networks, and web scraping.",
      features: ["LLM Integrations", "Data Science & NLP", "Automation Scripts", "FastAPI Framework"]
    },
    {
      name: "Unreal Engine",
      category: "ai-3d",
      logoType: "unreal",
      type: "Real-Time 3D Engine",
      desc: "World's most open and advanced real-time 3D creation tool for photoreal visuals and immersive interactive experiences.",
      features: ["Nanite & Lumen", "Real-Time Rendering", "Interactive Simulations", "C++ & Blueprints"]
    },
    {
      name: "MySQL, PostgreSQL & MongoDB",
      category: "backend",
      logoType: "db",
      type: "Database Systems",
      desc: "Robust relational (MySQL, PostgreSQL) and NoSQL (MongoDB) databases engineered for transactional integrity, complex relational schemas, and horizontal scale.",
      features: ["MySQL & PostgreSQL Relational Data", "ACID Compliance & Indexing", "MongoDB NoSQL Scale", "High Concurrency & Backups"]
    }
  ];

  const filteredTech = activeCategory === 'all'
    ? technologies
    : technologies.filter(item => item.category === activeCategory);

  const renderIcon = (logoType) => {
    switch (logoType) {
      case 'flutter':
        return <img src="/flutter-icon.png" alt="Flutter" className="tech-item-img" />;
      case 'firebase':
        return <img src="/firebase-icon.png" alt="Firebase" className="tech-item-img" />;
      case 'unreal':
        return <img src="/unreal-logo.png" alt="Unreal Engine" className="tech-item-img" />;
      case 'react':
        return (
          <svg width="44" height="44" viewBox="0 0 841.9 595.3" fill="#61DAFB">
            <path d="M666.3 296.5c0-32.5-40.7-63.3-103.1-82.4 14.4-63.6 8-114.2-20.2-130.4-6.5-3.8-14.1-5.6-22.4-5.6v22.3c4.6 0 8.3.9 11.4 2.6 13.6 7.8 19.5 37.5 14.9 75.7-1.1 9.4-2.9 19.3-5.1 29.4-19.6-4.8-41-8.5-63.5-10.9-13.5-18.5-27.5-35.3-41.6-50 32.6-30.3 63.2-46.9 84-46.9V78c-27.5 0-63.5 19.6-99.9 53.6-36.4-33.8-72.4-53.2-99.9-53.2v22.3c20.7 0 51.4 16.5 84 46.6-14 14.7-28 31.4-41.3 49.9-22.6 2.4-44 6.1-63.6 11-2.3-10-4-19.7-5.2-29-4.7-38.2 1.1-67.9 14.6-75.8 3-1.8 6.9-2.6 11.5-2.6V78.5c-8.4 0-16 1.8-22.6 5.6-28.1 16.2-34.4 66.7-19.9 130.1-62.2 19.2-102.7 49.9-102.7 82.3 0 32.5 40.7 63.3 103.1 82.4-14.4 63.6-8 114.2 20.2 130.4 6.5 3.8 14.1 5.6 22.5 5.6 27.5 0 63.5-19.6 99.9-53.6 36.4 33.8 72.4 53.2 99.9 53.2 8.4 0 16-1.8 22.6-5.6 28.1-16.2 34.4-66.7 19.9-130.1 62-19.1 102.5-49.9 102.5-82.3zm-130.2-66.7c-3.7 12.9-8.3 26.2-13.5 39.5-4.1-8-8.4-16-13.1-24-4.6-8-9.5-15.8-14.4-23.4 14.2 2.1 27.9 4.7 41 7.9zm-45.8 106.5c-7.8 13.5-15.8 26.3-24.1 38.2-14.9 1.3-30 2-45.2 2-15.1 0-30.2-.7-45-1.9-8.3-11.9-16.4-24.6-24.2-38-7.6-13.1-14.5-26.4-20.8-39.8 6.2-13.4 13.2-26.8 20.7-39.9 7.8-13.5 15.8-26.3 24.1-38.2 14.9-1.3 30-2 45.2-2 15.1 0 30.2.7 45 1.9 8.3 11.9 16.4 24.6 24.2 38 7.6 13.1 14.5 26.4 20.8 39.8-6.3 13.4-13.2 26.8-20.7 39.9zm32.3-13c5.4 13.4 10 26.8 13.8 39.8-13.1 3.2-26.9 5.9-41.2 8 4.9-7.7 9.8-15.6 14.4-23.7 4.6-8 8.9-16.1 13-24.1z" />
            <circle cx="420.9" cy="296.5" r="45.7" />
          </svg>
        );
      case 'node':
        return (
          <svg width="44" height="44" viewBox="0 0 256 289" fill="#689F63">
            <path d="M127.999 288.463c-3.975 0-7.685-1.06-11.061-2.121l-35.098-20.813c-5.301-2.833-2.65-3.814-1.061-4.519 6.539-2.298 7.951-2.833 14.845-6.892.795-.442 1.769-.265 2.564.177l26.981 16.116c1.061.618 2.386.618 3.182 0l105.205-60.814c1.061-.618 1.769-1.769 1.769-3.182V83.368c0-1.413-.708-2.564-1.769-3.182L127.999 19.372c-1.061-.618-2.386-.618-3.182 0L19.611 80.186c-1.061.618-1.769 1.769-1.769 3.182v121.321c0 1.413.708 2.564 1.769 3.182l28.837 16.646c15.729 7.951 25.274-1.413 25.274-10.832V92.731c0-1.769 1.413-3.182 3.182-3.182h13.783c1.769 0 3.182 1.413 3.182 3.182v120.791c0 21.079-11.451 33.235-31.381 33.235-6.186 0-10.832 0-24.204-6.539L10.832 223.572C4.204 219.951 0 212.354 0 204.403V83.368c0-7.951 4.204-15.548 10.832-19.169L116.037 3.385c6.539-3.621 15.195-3.621 21.734 0l105.205 60.814c6.628 3.621 10.832 11.218 10.832 19.169v121.035c0 7.951-4.204 15.548-10.832 19.169l-105.205 60.814c-3.182 1.769-7.157 2.65-11.061 2.65l.265-.353z" />
          </svg>
        );
      case 'db':
        return (
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#c084fc" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <ellipse cx="12" cy="5" rx="9" ry="3"/>
            <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/>
            <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
          </svg>
        );
      default:
        return (
          <div className="default-tech-icon">⚡</div>
        );
    }
  };

  return (
    <div className="technologies-page">
      <PageBanner
        badge="TECH STACK & ARCHITECTURE"
        title="Modern Technologies Built For"
        highlight="Extreme Performance"
        subtitle="We employ cutting-edge frontend, mobile, cloud, and AI frameworks to ensure your software is fast, resilient, and ready for rapid scale."
      />

      {/* Categories Filter Strip */}
      <section className="tech-filter-section">
        <div className="tech-page-container">
          <div className="category-filter-pills">
            {techCategories.map((cat) => (
              <button
                key={cat.id}
                type="button"
                className={`category-pill ${activeCategory === cat.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(cat.id)}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Technologies Cards Grid */}
      <section className="tech-grid-section">
        <div className="tech-page-container">
          <div className="technologies-cards-grid">
            {filteredTech.map((item, idx) => (
              <div key={idx} className="tech-card">
                <div className="tech-card-header">
                  <div className="tech-icon-box">
                    {renderIcon(item.logoType)}
                  </div>
                  <div className="tech-meta">
                    <span className="tech-type-label">{item.type}</span>
                    <h3 className="tech-name-heading">{item.name}</h3>
                  </div>
                </div>

                <p className="tech-card-desc">{item.desc}</p>

                <div className="tech-capabilities">
                  <span className="cap-label">Highlights:</span>
                  <div className="cap-tags">
                    {item.features.map((feat, fIdx) => (
                      <span key={fIdx} className="cap-tag">{feat}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Architecture Philosophy */}
      <section className="tech-philosophy-section">
        <div className="tech-page-container">
          <div className="philosophy-box">
            <span className="section-eyebrow">OUR ARCHITECTURAL PHILOSOPHY</span>
            <h2>Why Our Technology Choices Matter</h2>
            <div className="philosophy-grid">
              <div className="phi-item">
                <div className="phi-num">01</div>
                <h4>Zero Vendor Lock-in</h4>
                <p>We build with open, modern standards that give you complete ownership and freedom to deploy on any cloud or host.</p>
              </div>
              <div className="phi-item">
                <div className="phi-num">02</div>
                <h4>Maximum Developer Velocity</h4>
                <p>Frameworks like Flutter and React allow us to ship feature-complete products in half the time without sacrificing quality.</p>
              </div>
              <div className="phi-item">
                <div className="phi-num">03</div>
                <h4>Enterprise Scalability</h4>
                <p>Designed from day one to handle high traffic surges, high transaction volumes, and mission-critical workflows smoothly.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="tech-cta-section">
        <div className="tech-page-container">
          <div className="tech-cta-card">
            <h2>Have a specific tech stack in mind?</h2>
            <p>Our engineers can consult on the best architectural setup for your project requirements.</p>
            <Link to="/contact" className="btn-primary">
              <span>SCHEDULE A TECHNICAL CONSULTATION →</span>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Technologies;
